/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { isEmpty } from 'lodash';
import {
  Container,
  ActionsContainer,
  SubmitButton,
  Input,
  ContentContainer,
  CancelButton,
  DialogContent,
  FormHelperText,
  CardHeader,
  HeaderContainer,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  DialogActions,
  ProgressContainer,
} from './styles';
import restApiClient from '../../services/restApiClient';
import { CircularProgress } from '@material-ui/core';

function ClinicAdjustStockDialog({
  onSuccess,
  onError,
  onCancel,
  item,
  ...props
}) {
  const [quantity, setQuantity] = useState('');
  const [type, setType] = useState('');
  const [justification, setJustification] = useState('');
  const [errors, setErrors] = useState([]);
  const [fetching, setFetching] = useState(false);
  const typesStockHistory = [
    { value: 'input', label: 'Entrada' },
    { value: 'output', label: 'Saída' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(errors)) {
      setFetching(true);
      restApiClient.clinicAdjustmentHistory
        .adjustQuantityStock({
          itemId: item.id,
          quantity: parseInt(quantity),
          type,
          justification,
        })
        .then(() => {
          onSuccess?.();
          setQuantity('');
          setType('');
          setJustification('');
          setErrors([]);
          setFetching(false);
        })
        .catch((x) => {
          if (x.response?.status === 400) {
            onError?.(x.response);
            setErrors(x.response.data.errors);
            setFetching(false);
          }
        });
    }
  };

  return (
    <Container>
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...props}
      >
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <DialogContent>
            <Card>
              <HeaderContainer>
                <CardHeader title="Ajustar Quantidade" />
              </HeaderContainer>
              <ContentContainer>
                <FormControl
                  required
                  size="small"
                  error={!isEmpty(errors?.type)}
                >
                  <InputLabel htmlFor="outlined-selectedUnit-native-simple">
                    Tipo de Ajuste
                  </InputLabel>
                  <Select
                    value={type || ''}
                    label="Tipo de Ajuste"
                    onChange={(e) => {
                      setErrors([]);
                      setType(e.target.value);
                    }}
                  >
                    {[
                      <MenuItem value="" key={'empty'}>
                        <em>Nenhuma</em>
                      </MenuItem>,
                    ].concat(
                      typesStockHistory?.map((optionValue) => (
                        <MenuItem
                          value={optionValue.value}
                          key={optionValue.value}
                        >
                          {optionValue.label}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  <FormHelperText>
                    {!isEmpty(errors?.type) ? errors?.type.join(' ') : ''}
                  </FormHelperText>
                </FormControl>
                <Input
                  required
                  type="number"
                  label="Quantidade"
                  value={quantity}
                  InputProps={{ inputProps: { min: 1 } }}
                  onChange={(e) => {
                    setErrors([]);
                    setQuantity(e.target.value);
                  }}
                  error={!isEmpty(errors?.quantity)}
                  helperText={
                    !isEmpty(errors?.quantity) ? errors?.quantity.join(' ') : ''
                  }
                />
                <Input
                  id="justification"
                  size="normal"
                  label="Justificativa"
                  value={justification}
                  multiline
                  inputProps={{ maxLength: 250 }}
                  onChange={(e) => {
                    setErrors({});
                    setJustification(e.target.value);
                  }}
                  error={!isEmpty(errors?.justification)}
                  helperText={
                    !isEmpty(errors?.justification)
                      ? errors?.justification.join(' ')
                      : ''
                  }
                  required
                />
              </ContentContainer>
            </Card>
            <DialogActions>
              <ActionsContainer>
                <CancelButton
                  onClick={() => {
                    setErrors([]);
                    setType('');
                    setQuantity('');
                    setJustification('');
                    setFetching(false);
                    onCancel?.();
                  }}
                  type="button"
                  variant="contained"
                  color="primary"
                >
                  Cancelar
                </CancelButton>
                {fetching ? (
                  <ProgressContainer>
                    <CircularProgress size={24} />
                  </ProgressContainer>
                ) : (
                  <SubmitButton
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Ajustar
                  </SubmitButton>
                )}
              </ActionsContainer>
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>
    </Container>
  );
}

export default ClinicAdjustStockDialog;
